// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import {
  CreateReturnOrderRequest,
  ReturnOrder,
  reasonToAPI,
  returnOrderSchema,
} from '@/return-order/api/types';
import { serializeDateForAPI } from '@/utilities/date-time';

/**
 * Type definition for the API response wrapper.
 */
interface ApiResponse {
  data: unknown;
  metadata: { requestId: string };
}

/**
 * Creates a new return order with the specified details.
 */
export async function createReturnOrder(
  request: CreateReturnOrderRequest
): Promise<ReturnOrder> {
  const url = '/v1/return-order';

  // Convert type to API format (uppercase)
  const apiRequest = {
    ...request,
    returnType: reasonToAPI(request.returnType),
    promiseShipDate: serializeDateForAPI(request.promiseShipDate),
    promiseDeliveryDate: serializeDateForAPI(request.promiseDeliveryDate),
  };

  const response = await api.post<ApiResponse>(url, apiRequest);

  // Parse and validate the response with Zod
  return parseResponse(returnOrderSchema, response.data.data, {
    schemaName: 'CreateReturnOrder',
    endpoint: url,
  });
}
